import { render } from "./invoicePopup.vue?vue&type=template&id=b23b52ea&scoped=true"
import script from "./invoicePopup.vue?vue&type=script&lang=js"
export * from "./invoicePopup.vue?vue&type=script&lang=js"

import "./invoicePopup.vue?vue&type=style&index=0&id=b23b52ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23b52ea"]])

export default __exports__